export default __webpack_public_path__ + "static/media/appartement.07a37a34.jpg";